import type { FaireProductEntity } from "../../entity_types/product";

export const p_byi5dlfm: FaireProductEntity = {
  token: "p_byi5dlfm",
  type: "product",
  name: "Golden Coast - Incense Sticks",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/d3558a88be489103f847ea2992b75fbcff5e027b2c19bdedc8288a8da34afd8c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f0538d86ed8fd6c5aec953f250cf777abadecc36b528bf37e721472aefd00928.jpeg",
    "https://cdn.faire.com/fastly/9fcfb23609c7ee9533351b7ad43d4460ae7e6228c97fa39d6d3995df84f61818.jpeg",
    "https://cdn.faire.com/fastly/33dc47d37698aed017cd2303808ec585cdfd016104910b6f319d1209f8fb2e0e.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/41db24fd9063c264330da38383dae63613a26b7f136eac29b3b925821c80ec91.jpeg",
    "https://cdn.faire.com/fastly/9d0bd272bd3218e678e2ad4d572062a04d096c083b603c5391706273149cb761.jpeg",
  ],
  priceDollars: 5,
  description:
    'Big Sur magic, wild sage baking in the sun, the rumble of waves and rocks. Notes of eucalyptus, sea salt, redwood, and palo santo.\n\nOur hand-dipped charcoal incense quickly transforms a room: transformative smoke uplifts the space while our signature scents linger for hours even after extinguishing.\n\nEach stick burns for 1 hour; depending on room size, scent longevity lasts between 2-4 hours. 15 sticks in a plastic sleeve inside of each kraft package, measuring 10.75" long each.',
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:44.776Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
